/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(individualId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetIndividualLicenseByIndividual: {
        $xmlns: 'http://dobs.pa.gov/sc/individuallicense/bpm/1.0',
        IndividualID: individualId
      }
    },
    blueprintArrays: ['GetIndividualLicenseByIndividualResponse.SC_IndividualLicense'],
    blueprint: {
      individualLicenses: [
        '$..SC_IndividualLicense',
        {
          licenseId: '$..ID',
          individualId: '$..IndividualID',
          organizationId: '$..OrganizationID',
          applicantLegalName: '$..ApplicantLegalName',
          dbaName: '$..DBAName',
          organizationCRDNumber: '$..OrganizationCRDNumber',
          licenseTypeID: '$..LicenseTypeID',
          licenseType: '$..Type',
          licenseStatusID: '$..LicenseStatusID',
          licenseStatus: '$..Status',
          licenseStatusDate: '$..LicenseStatusDate'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      _.each(response.individualLicenses, function(license) {
        if (license.licenseStatusDate) {
          license.licenseStatusDate = moment(license.licenseStatusDate, 'YYYY-MM-DD');
        }
      });

      deferred.resolve(response.individualLicenses);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
